import React from 'react';
import styled from 'styled-components';
import { Typo } from 'tmt-ui-kit';
import PropTypes from 'prop-types';

const Container = styled.div`
  background-image: url('${props => props.backgroundImage}');
  height: 650px;
  background-size: cover;
  background-position: 50% 50%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  @media(max-width: 1200px) {
    height: 432px;
  }
  @media(max-width: 600px) {
    height: 280px;
    text-align: left;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 32px 24px;
  }
`;

const Title = styled(Typo.HeaderOne)`
  z-index: 5;
  font-size: 42px !important;
  color: ${props => props.theme.white} !important;
  margin: 0;
  @media(max-width: 1200px) {
    font-size: 36px !important;
  }
  @media(max-width: 600px) {
    font-size: 24px !important;
  }
`;

const BannerOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, .6), rgba(0, 0, 0, .43) 14%, rgba(0, 0, 0, .3) 22%, rgba(0, 0, 0, .0));
  z-index: 5;
`;

const PageBanner = props => {
  return (
    <Container backgroundImage={props.backgroundImage}>
      <BannerOverlay />
      <Title>{props.renderTitle()}</Title>
    </Container>
  );
};

PageBanner.propTypes = {
  renderTitle: PropTypes.func,
  backgroundImage: PropTypes.string
};

export default PageBanner;
